import * as THREE from 'three';
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js';
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js';

// 1. SCENA
const scene = new THREE.Scene();
scene.background = new THREE.Color(0xcecece); // Jasnoszare tło - MUSI być widoczne

// 2. KAMERA
const camera = new THREE.PerspectiveCamera(75, window.innerWidth / window.innerHeight, 0.1, 2000);
camera.position.set(5, 5, 5);

// 3. RENDERER
const renderer = new THREE.WebGLRenderer({ antialias: true });
renderer.setSize(window.innerWidth, window.innerHeight);
// Dodajemy renderer do body (upewnij się, że body ma wysokość 100vh w CSS)
document.body.style.margin = '0';
document.body.appendChild(renderer.domElement);

// 4. OŚWIETLENIE - kluczowe dla GLTF
const hemiLight = new THREE.HemisphereLight(0xffffff, 0x444444, 2);
scene.add(hemiLight);

const dirLight = new THREE.DirectionalLight(0xffffff, 2);
dirLight.position.set(5, 10, 7);
scene.add(dirLight);

// 1. Inicjalizacja ładowania tekstur
const textureLoader = new THREE.TextureLoader();







// 5. KONTROLA I OGRANICZENIA ZOOMU
const controls = new OrbitControls(camera, renderer.domElement);

controls.target.set(0, 0, 0); // Stały punkt obrotu w centrum
controls.enableDamping = true; // Dodaje płynności (efekt "masy" przy obracaniu)
controls.dampingFactor = 0.05;

// --- TWOJE LIMITY ---
// Wartości dopasuj do skali swoich modeli (np. 10 to blisko, 100 to daleko)
controls.minDistance = 0;   
controls.maxDistance = 3;

// 6. ŁADOWANIE MODELI
const MODEL_FILES = [
    { name: 'Model 1', url: 'models/ShohiZinda_2_1.glb' },
    { name: 'Model 2', url: 'models/ShohiZinda_2_2.glb' }
];

const loader = new GLTFLoader();

MODEL_FILES.forEach(m => {
    loader.load(m.url, (gltf) => {
        console.log("Załadowano:", m.name);
        scene.add(gltf.scene);
    }, 
    (xhr) => { console.log((xhr.loaded / xhr.total * 100) + '%'); },
    (err) => { console.error("Błąd ładowania:", m.name, err); });
});

// 2. Ładowanie obrazu panoramicznego
textureLoader.load('pano/ShohiZinda_pano.jpg', (texture) => {
    // Ustawienie mapowania na sferyczne (equirectangular)
    texture.mapping = THREE.EquirectangularReflectionMapping;
   // texture.colorSpace = THREE.SRGBColorSpace; // Zapewnia poprawne kolory

    // Ustawienie tekstury WYŁĄCZNIE jako tło sceny
    scene.background = texture;
    
    // UWAGA: Nie ustawiamy scene.environment, 
    // dzięki temu tło NIE wpływa na oświetlenie obiektów.
});


// 7. PĘTLA RENDEROWANIA (uruchomiona od razu dla testu)
function animate() {
    requestAnimationFrame(animate);
    controls.update();
    renderer.render(scene, camera);
}
animate();


// Funkcja przełączająca tryb pełnego ekranu
function toggleFullScreen() {
    // Sprawdzamy, czy cokolwiek jest już w trybie pełnoekranowym
    const fullscreenElement = document.fullscreenElement || document.webkitFullscreenElement;

    if (!fullscreenElement) {
        // Wejdź w tryb pełnego ekranu (na elemencie body lub renderer.domElement)
        const canvas = document.documentElement; // Cała strona w iframe
        if (canvas.requestFullscreen) {
            canvas.requestFullscreen();
        } else if (canvas.webkitRequestFullscreen) {
            canvas.webkitRequestFullscreen(); // Safari
        }
    } else {
        // Wyjdź z trybu pełnego ekranu
        if (document.exitFullscreen) {
            document.exitFullscreen();
        } else if (document.webkitExitFullscreen) {
            document.webkitExitFullscreen();
        }
    }
}

// OPCJA A: Obsługa klawisza "F"
window.addEventListener('keydown', (event) => {
    if (event.key === 'f' || event.key === 'F') {
        toggleFullScreen();
    }
});

// OPCJA B: Obsługa podwójnego kliknięcia na canvasie
renderer.domElement.addEventListener('dblclick', () => {
    toggleFullScreen();
});




// Resizing
window.addEventListener('resize', () => {
    camera.aspect = window.innerWidth / window.innerHeight;
    camera.updateProjectionMatrix();
    renderer.setSize(window.innerWidth, window.innerHeight);
});